import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorPageQueryParameters } from '../pages/error-page/error-page.component';
import { NavRoutes } from 'src/app/core/constants/nav.routes';

@Injectable({
    providedIn: 'root'
})
export class ErrorRouter {
    
    constructor(private router: Router) { }
    
    public navigateToServerConnectionError(): void {
        let queryParams = {
            headerText: "Connection Error",
            subText: "We couldn't find our servers, check your connection and try again!",
            materialIconName: "error",
            materialIconColorClass: "color-warn",
            onClickButtonName: "Reload Page",
        } as ErrorPageQueryParameters;

        this.router.navigate([NavRoutes.Error], { queryParams: queryParams, skipLocationChange: true });
    }

    public navigateToNotFound(): void {
        let queryParams = {
            headerText: "Not Found",
            subText: "We couldn't find what you're looking for!",
            materialIconName: "help",
            materialIconColorClass: "color-warn",
            onClickButtonName: "Home",
            onClickNavigationRoute: NavRoutes.Root
        } as ErrorPageQueryParameters;

        this.router.navigate([NavRoutes.Error], { queryParams: queryParams, skipLocationChange: true });
    }

    public navigateToUnauthorized(): void {
        let queryParams = {
            headerText: "Unauthorized",
            subText: "You are restricted from this resource. If you think this is a mistake, contact an administrator for assistance.",
            materialIconName: "lock",
            materialIconColorClass: "color-error",
            onClickButtonName: "Log In",
            onClickNavigationRoute: NavRoutes.Root
        } as ErrorPageQueryParameters;

        this.router.navigate([NavRoutes.Error], { queryParams: queryParams, skipLocationChange: true });
    }

    public navigateToInternalError(): void {
        let queryParams = {
            headerText: "Oops something went wrong",
            subText: "If this problem persists contact contact an administrator for assistance.",
            materialIconName: "error",
            materialIconColorClass: "color-error",
            onClickButtonName: "Reload Page",
        } as ErrorPageQueryParameters;

        this.router.navigate([NavRoutes.Error], { queryParams: queryParams, skipLocationChange: true });
    }

    public navigateToCustomError(queryParams: ErrorPageQueryParameters): void {
        this.router.navigate([NavRoutes.Error], { queryParams: queryParams, skipLocationChange: true });
    }
}
